import React from "react"
import { View, StyleSheet } from "react-native"
import { ScreenSkeleton } from "../common/screens/ScreenSkeleton"
import TextM from "../common/components/text/TextM"
import FilledButtonM from "../common/components/button/FilledButtonM"
import { theme } from "../common/theme/theme"
import { ChampionImageM } from "../student/champions/ChampionImageM"

export const FastTrackAssessmentCheckStep = ({
    user,
    onAssessmentPrepare,
    onClassicSupport,
}) => {
    return (
        <ScreenSkeleton withCenterContent>
            <View style={styles.card}>
                {/* Zoé champion */}
                <ChampionImageM name="zoe" variant="main" width={120} />

                <View style={styles.textContainer}>
                    <TextM
                        fontSize={22}
                        fontWeight="ExtraBold"
                        color={theme.colors.primary}
                        wrap
                        center
                    >
                        Est-ce que {user?.firstname} a un contrôle bientôt ?
                    </TextM>

                    <TextM
                        fontSize={15}
                        color={theme.colors.grey}
                        wrap
                        center
                    >
                        On peut se concentrer dessus lors de la séance
                        découverte.
                    </TextM>
                </View>

                <View style={styles.buttonsContainer}>
                    <FilledButtonM
                        label="Oui, préparer le contrôle"
                        onPress={onAssessmentPrepare}
                        color={theme.colors.success}
                        style={styles.button}
                        wrapText
                    />

                    <FilledButtonM
                        label="Non, continuer"
                        onPress={onClassicSupport}
                        mode="outlined"
                        color={theme.colors.primary}
                        style={styles.button}
                        wrapText
                    />
                </View>
            </View>
        </ScreenSkeleton>
    )
}

const styles = StyleSheet.create({
    card: {
        backgroundColor: theme.colors.white,
        alignItems: "center",
        gap: 24,
        borderRadius: 24,
        padding: 32,
        paddingTop: 40,
        shadowColor: theme.colors.black,
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.12,
        shadowRadius: 12,
        elevation: 8,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
    },
    textContainer: {
        alignItems: "center",
        gap: 12,
    },
    buttonsContainer: {
        width: "100%",
        gap: 12,
        marginTop: 8,
    },
    button: {
        width: "100%",
        marginBottom: 0,
        height: 56,
    },
})
